"use client";

import React from "react";
import { TourHighlightsSection } from "@/types/dto/destinations-page/destination-page-types";
import GenericLazyLoader from "@/components/common/generic-lazy-loader";

interface TourHighlightsSectionProps {
  tourHighlightsSection: TourHighlightsSection;
}

const LazyLoadTourHighlightsComponent = ({ tourHighlightsSection }: TourHighlightsSectionProps) => 

    <GenericLazyLoader
      importComponent={() => import("./tour-highlights-section")}
      componentProps={{ tourHighlightsSection }}
      debugName="Tour Highlights"
      threshold={0.1}
      rootMargin="200px 0px"
    />;


export default LazyLoadTourHighlightsComponent;